export const TRADE = {
  TRADELIST: 'tradeList',
  DETAILS: 'tradeDetails',
  ASSOCIATED_DETAILS: 'associatedTradeDetails',
  CREATEMETADATA: {
    KEY: 'createMetadata'
  },
  COUNT: {
    KEY: 'tradeCount',
    REFETCH_INTERVAL: 60 * 1000 * 5
  }
};

export const VEHICLE = {
  MANUFACTURERLIST: 'manufacturerList',
  REFETCH_INTERVAL: 60 * 1000 * 20
};

export const BID = {
  KEY: {
    CREATE: 'create',
    PLACE: 'place'
  }
};

export const BID_LIST = {
  KEY: 'bidList',
  REFETCH_INTERVAL: 60 * 1000 * 20
};

export const FEATURE_FLAG = {
  KEY: 'featureFlag',
  REFETCH_INTERVAL: 60 * 1000 * 20,
  MAX_FAILURE_COUNT: 3
};

export const SHIPPING = {
  KEY: 'shipping',
  REFETCH_INTERVAL: 60 * 1000 * 60
};

export const SHIPPING_OMP = {
  KEY: 'shipping',
  REFETCH_INTERVAL: 60 * 1000 * 60,
  STALE_TIME: 0
};

export const TERMS_AND_CONDITIONS = {
  KEY: 'termsAndConditions',
  REFETCH_INTERVAL: 60 * 1000 * 60
};

export const TERMS_AND_CONDITIONS_OMP = {
  KEY: 'termsAndConditions',
  REFETCH_INTERVAL: 60 * 1000 * 60,
  STALE_TIME: 0
};

export const DEALER_BADGES = {
  KEY: 'dealerBadges',
  STALE_TIME: 1000 * 60 * 5,
  DEFAULT_RESPONSE: []
};

export const LIST = {
  FILTERLIST: {
    KEY: 'filterList',
    STALE_TIME: 1000 * 60 * 5
  },
  LISTMETADATA: {
    KEY: 'listMetadata'
  },
  MEDIA: {
    KEY: 'mediaList',
    STALE_TIME: 1000 * 60 * 60
  },
  SORTMETADATA: {
    KEY: 'sortMetaData'
  },
  SELLPENDING: {
    DECISION: {
      KEY: 'sellPendingDecision'
    },
    NEGOTIATION: {
      KEY: 'sellPendingNegotiation'
    },
    PROPOSALS: {
      KEY: 'getProposals'
    }
  },
  BUYPENDING: {
    DECISION: {
      KEY: 'buyPendingDecision'
    },
    NEGOTIATION: {
      KEY: 'buyPendingNegotiation'
    }
  }
};

export const ACTIVITY = {
  GET_PAYMENT_ON_HOLD_SUMMARY: {
    KEY: 'getPaymentOnHoldSummary',
    STALE_TIME: 0
  },
  GET_PAYMENT_ON_HOLD_METADATA: {
    KEY: 'getPaymentOnHoldMetadata',
    STALE_TIME: 0
  },
  GET_PAYMENT_ON_HOLD_TRADE_LIST: {
    KEY: 'getPaymentOnHoldTradeList',
    STALE_TIME: 0
  },
  GET_ETR_PAYMENT_ON_HOLD_TRADE_LIST: {
    KEY: 'getEtrPaymentOnHoldTradeList',
    STALE_TIME: 0
  }
};

export const SEARCH = {
  BUYLIST: 'searchBuyList',
  SELLLIST: 'searchSellList'
};

export const ORGANIZATION = {
  GETDEALER: {
    KEY: 'getDealer'
  }
};

export const RETAIL = {
  GETDEALERLOCATIONS: {
    KEY: 'getDealerLocation'
  }
};

export const TODO = {
  TODOLIST: 'todoList',
  STALE_TIME: 1000 * 60 * 5
};

export const ALERT = {
  ALERTLIST: 'alertList',
  STALE_TIME: 1000 * 60 * 5
};

export const USER = {
  IS_SELLER: {
    KEY: 'isSeller'
  },
  USERLIST: {
    KEY: 'userList',
    REFETCH_INTERVAL: 1000 * 60 * 60 * 12
  }
};

export const RESEARCH = {
  RESEARCHDETAILS: 'researchDetails'
};

export const LOCALSTORAGELIST = [
  FEATURE_FLAG.KEY,
  VEHICLE.MANUFACTURERLIST,
  TRADE.COUNT.KEY,
  TODO.TODOLIST,
  ALERT.ALERTLIST,
  LIST.SORTMETADATA.KEY,
  USER.USERLIST.KEY
];

export const SESSIONSTORAGELIST = [LIST.FILTERLIST.KEY];

export const CACHE = {
  query: 'queryCache',
  mutation: 'mutationCache'
};

// To be removed after
export const TEMP_PENDING_OFFSET = 0;
export const TEMP_PENDING_SIZE = 100;
